import React, { useEffect, useMemo, useRef, useState } from 'react';
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Collapse,
  FormControlLabel,
  Checkbox,
} from '@material-ui/core';
import styles from 'assets/jss/material-dashboard-pro-react/views/regularFormsStyle';
import { Add, Close, Remove, ShutterSpeedTwoTone, Visibility } from '@material-ui/icons';
import CardContainer from 'components/Tvendo/Common/CardContainer';
import ModalFull from 'components/Tvendo/Common/ModalFull';
import GridContainer from 'components/Grid/GridContainer';
import { makeStyles } from '@material-ui/core/styles';
import Button from 'components/CustomButtons/Button';
import GridItem from 'components/Grid/GridItem';
import { wsFindBy } from 'services/WService';
import Table from 'components/Table/Table';
import { formatDate } from 'hooks/Pipe';
import { Link } from 'react-router-dom';

const pinColors = ['blue', 'yellow', 'red', 'green', 'purple', 'orange', 'pink'];
const useStyles = makeStyles(styles);

function SplitSheet(props) {
  const { sheetDistribution } = props;
  const { orders, setOrders } = props;
  const { routes, setRoutes } = props;
  const { sheets, setSheets } = props;
  const [nextId, setNextId] = useState(1);

  const [vehicles, setVehicles] = useState([]);
  const [jefeMercas, setJefeMercas] = useState([]);
  const [jefeDists, setJefeDists] = useState([]);

  // Modal
  const [orderModalOpen, setModalOrderOpen] = useState(false);
  const [currentSheet, setCurrentSheet] = useState();

  function removeSheet(id) {
    setSheets((sheets) => {
      let newSheets = [...sheets];
      let index = newSheets.findIndex((sheet) => sheet.id === id);
      newSheets.splice(index, 1);
      return newSheets;
    });
    setOrders((orders) => {
      let newOrders = orders.map((order) => {
        if (order.sheetId === id) {
          delete order.sheetId;
          delete order.pinColor;
        }
        return order;
      });
      return newOrders;
    });
  }

  async function listVehicles() {
    let response = await wsFindBy('prog/vehicle', { base_zone_id: sheetDistribution.base_zone_id });
    if (response.success) {
      setVehicles(response.data);
    }
  }

  async function listManagers() {
    let response = await wsFindBy('prog/distribution-staff', {
      base_zone_id: sheetDistribution.base_zone_id,
    });
    if (response.success) {
      setJefeMercas(response.data.filter((item) => item.base_employee_positon_id == '1'));
      setJefeDists(response.data.filter((item) => item.base_employee_positon_id == '2'));
    }
  }

  useEffect(() => {
    if (sheetDistribution?.id === undefined) return;
    listVehicles();
    listManagers();
  }, [sheetDistribution]);

  const unsignedOrders = useMemo(() => {
    return orders.filter((order) => order.sheetId === undefined).length;
  }, [orders]);

  return (
    <CardContainer
      title={
        <>
          <p>Nuevas hojas</p>
          <p>{unsignedOrders === 0 ? '' : ` Faltan asignar ${unsignedOrders} pedidos`}</p>
        </>
      }
      onClick={() => {
        if (sheetDistribution.id === undefined) return;
        setSheets((sheets) => {
          let pinColor = '';
          let usedColors = sheets.map((sheet) => sheet.pinColor);
          for (let color of pinColors) {
            if (usedColors.includes(color)) continue;
            pinColor = color;
            break;
          }

          if (pinColor === '') {
            return sheets;
          }

          return [
            ...sheets,
            {
              id: nextId,
              prog_vehicle_id: sheetDistribution.prog_vehicle_id,
              prog_distribution_staff_id_manager:
                sheetDistribution.prog_distribution_staff_id_manager,
              prog_distribution_staff_id_inventory_manager:
                sheetDistribution.prog_distribution_staff_id_inventory_manager,
              pinColor,
            },
          ];
        });
        setNextId((nextId) => nextId + 1);
      }}
      icon={<Add />}
    >
      <OrdersModal
        open={orderModalOpen}
        setOpen={setModalOrderOpen}
        orders={orders}
        setOrders={setOrders}
        routes={routes}
        currentSheet={currentSheet}
        sheets={sheets}
      />
      <GridContainer>
        {sheets.map((sheet) => {
          return (
            <NewSheetItem
              key={sheet.id}
              sheet={sheet}
              setSheets={setSheets}
              removeSheet={removeSheet}
              vehicles={vehicles}
              jefeDists={jefeDists}
              jefeMercas={jefeMercas}
              setModalOrderOpen={setModalOrderOpen}
              currentSheet={currentSheet}
              setCurrentSheet={setCurrentSheet}
              orders={orders}
            />
          );
        })}
      </GridContainer>
    </CardContainer>
  );
}

function NewSheetItem(props) {
  const { sheet, setCurrentSheet, setSheets, orders } = props;
  const { removeSheet, vehicles, jefeDists, jefeMercas } = props;
  const { setModalOrderOpen } = props;

  function selectVehicle(vehicle) {
    setSheets((sheets) => {
      let newSheets = [...sheets];
      let index = newSheets.findIndex((item) => item.id === sheet.id);
      newSheets[index] = {
        ...newSheets[index],
        prog_vehicle_id: vehicle.id,
        prog_distribution_staff_id_manager: vehicle.prog_distribution_staff_id_manager,
        prog_distribution_staff_id_inventory_manager:
          vehicle.prog_distribution_staff_id_inventory_manager,
      };
      return newSheets;
    });
  }

  function setValue(field, value) {
    setSheets((sheets) => {
      let newSheets = [...sheets];
      let index = newSheets.findIndex((item) => item.id === sheet.id);
      newSheets[index] = {
        ...newSheets[index],
        [field]: value,
      };
      return newSheets;
    });
  }

  return (
    <GridItem xs={12} sm={6} lg={4} xl={3}>
      <GridContainer>
        <GridItem xs={12}>
          <Button
            justIcon
            color="primary"
            onClick={() => {
              setModalOrderOpen(true);
              setCurrentSheet(sheet.id);
            }}
          >
            <ShutterSpeedTwoTone />
          </Button>
          <Button justIcon onClick={() => removeSheet(sheet.id)} color="danger">
            <Close />
          </Button>

          <img src={`https://maps.google.com/mapfiles/ms/icons/${sheet.pinColor}-dot.png`} />

          <h4>Pedidos asignados: {orders.filter((order) => order.sheetId === sheet.id).length}</h4>
        </GridItem>
        <GridItem xs={12}>
          <FormControl fullWidth size="small" required margin="normal">
            <InputLabel>Vehículo</InputLabel>
            <Select value={sheet.prog_vehicle_id || ''}>
              {vehicles.map((vehicle) => (
                <MenuItem
                  key={vehicle.id}
                  value={vehicle.id}
                  onClick={() => {
                    selectVehicle(vehicle);
                  }}
                >
                  {vehicle.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth size="small" required margin="normal">
            <InputLabel>Jefe Reparto</InputLabel>
            <Select
              value={sheet.prog_distribution_staff_id_manager || ''}
              onChange={(e) => setValue('prog_distribution_staff_id_manager', e.target.value)}
            >
              {jefeDists.map((item) => (
                <MenuItem value={item.id} key={item.id}>
                  {item.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth size="small" required margin="normal">
            <InputLabel>Encargado de mercadería</InputLabel>
            <Select
              value={sheet.prog_distribution_staff_id_inventory_manager || ''}
              onChange={(e) =>
                setValue('prog_distribution_staff_id_inventory_manager', e.target.value)
              }
            >
              {jefeMercas.map((item, i) => (
                <MenuItem value={item.id} key={item.id}>
                  {item.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </GridItem>
      </GridContainer>
    </GridItem>
  );
}

function OrdersModal(props) {
  const { open, setOpen, routes } = props;
  const { orders, setOrders, currentSheet, sheets } = props;
  const modalRef = useRef(null);

  const pinColor = useMemo(() => {
    return sheets.find((sheet) => currentSheet === sheet.id)?.pinColor;
  }, [currentSheet, sheets]);

  function handleClose() {
    let checkboxes = modalRef.current.querySelectorAll('.checkbox-order');
    let data = [];
    for (let input of checkboxes) {
      data.push({ id: parseInt(input.name), checked: input.checked });
    }

    setOrders((orders) => {
      let newOrders = [...orders];
      return newOrders.map((order) => {
        if (order.sheetId !== undefined && order.sheetId !== currentSheet) {
          return order;
        }

        let row = data.find((row) => row.id === order.id);
        order.checked = row.checked;
        if (order.checked) {
          order.sheetId = currentSheet;
          order.pinColor = pinColor;
        } else {
          delete order.sheetId;
          delete order.pinColor;
        }
        return order;
      });
    });
    setOpen(false);
  }

  return (
    <ModalFull title={`Pedidos faltantes a asignar`} open={open} setOpen={() => handleClose()}>
      <div ref={modalRef}>
        {routes.map((route) => {
          let filteredOrders = orders.filter(
            (order) => parseFloat(order.base_route_id) === route.id,
          );
          return (
            <RouteItem
              key={route.id}
              route={route}
              orders={filteredOrders}
              setOrders={setOrders}
              currentSheet={currentSheet}
              modalRef={modalRef}
              pinColor={pinColor}
            />
          );
        })}
      </div>
    </ModalFull>
  );
}

function RouteItem(props) {
  const classes = useStyles();
  const { orders, pinColor, route, currentSheet, modalRef } = props;
  const [collapsed, setCollapsed] = useState(true);
  const [routeDisabled, setRouteDisabled] = useState(false);
  const [routeChecked, setRouteChecked] = useState(true);
  const [indeterminate, setIndeterminate] = useState(false);

  function checkRoute() {
    let checkboxes = modalRef.current.querySelectorAll('.checkbox-order');
    for (let input of checkboxes) {
      let order = orders.find((order) => order.id === parseInt(input.name));
      if (order === undefined) continue;
      if (order.sheetId !== undefined && order.sheetId !== currentSheet) {
        continue;
      }
      if (parseInt(order.base_route_id) === route.id) {
        input.checked = routeChecked;
      }
    }
    setIndeterminate(false);
    setRouteChecked((checked) => !checked);
  }

  function onCheckedChange() {
    setIndeterminate(true);
    setRouteChecked(false);
  }

  useEffect(() => {
    let routeOrders = orders.filter((order) => parseFloat(order.base_route_id) === route.id);

    let disabledOrders = orders.filter(
      (order) => order.sheetId !== undefined && order.sheetId !== currentSheet,
    );

    if (disabledOrders.length === routeOrders.length) {
      setRouteDisabled(true);
      setRouteChecked(true);
    }

    let checkedCount = routeOrders.filter((order) => order.checked === true).length;
    if (checkedCount === routeOrders.length) {
      setRouteChecked(false);
      setIndeterminate(false);
    } else if (checkedCount === 0) {
      setRouteChecked(true);
      setIndeterminate(false);
    } else {
      setRouteChecked(false);
      setIndeterminate(true);
    }
  }, [orders]);

  return (
    <div key={route.id}>
      <div style={{ display: 'flex' }}>
        <div style={{ flex: 1 }}>
          <h4>
            <strong>
              {route.code} {route.description}
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={routeDisabled}
                    onChange={() => checkRoute()}
                    checked={!routeChecked}
                    indeterminate={indeterminate}
                  />
                }
              />
            </strong>
            <p>Pedidos:{orders.length}</p>
          </h4>
        </div>
        <Button justIcon onClick={() => setCollapsed((collapse) => !collapse)} color="success">
          {collapsed ? <Add /> : <Remove />}
        </Button>
      </div>

      <Collapse in={!collapsed}>
        <div style={{ overflowY: 'scroll', maxHeight: '500px' }}>
          <Table
            striped
            tableHead={[
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={routeDisabled}
                    onChange={() => checkRoute()}
                    checked={!routeChecked}
                    indeterminate={indeterminate}
                  />
                }
              />,
              'Cliente',
              'Monto',
              'Dirección',
              'Fecha',
              'Vendedor',
            ]}
            tableData={orders.map((order, index) => {
              return [
                <>
                  <FormControlLabel
                    control={
                      <input
                        type="checkbox"
                        disabled={order.sheetId !== undefined && order.sheetId !== currentSheet}
                        className="checkbox-order"
                        name={`${order.id}`}
                        defaultChecked={order.checked === true}
                        key={orders}
                        onChange={onCheckedChange}
                      />
                    }
                  />
                  <Button justIcon round simple color="primary">
                    <Link to={`/admin/ventas/operaciones/pedidos/#${order.id}`} target="_blank">
                      <Visibility />
                    </Link>
                  </Button>
                  {order.pinColor !== undefined && (
                    <img
                      src={`https://maps.google.com/mapfiles/ms/icons/${order.pinColor}-dot.png`}
                    />
                  )}
                </>,
                <>
                  <p>{order.CardCode}</p>
                  <p>{order.CardName}</p>
                </>,
                `S/ ${parseFloat(order.total_order).toFixed(2)}`,
                order.Address2,
                formatDate(order.date_order, 'F'),
                order.SlpName,
              ];
            })}
          />
        </div>
      </Collapse>
    </div>
  );
}

export default SplitSheet;
